import { Button, ButtonLink } from "@/components/Buttons/index";
import modalStyles from "@/styles/Modal.module.scss";
import config from "@/lib/config";

export default function IdcSignUpModal({ onClickHandle }) {
  return (
    <div className={modalStyles.logout}>
      <p className={modalStyles.text}>
        Myスカパー！IDをお持ちではありませんか？
      </p>
      <p className={modalStyles.caption}>
        Myスカパー！IDをお持ちの方はMyスカパー！から会員移行するをお選びください。
        <br />
        ※以前のポイントが消失する場合がございます。
      </p>
      <div className={modalStyles.loginButtons}>
        <ButtonLink
          type="button"
          fillColor
          large
          fillGray
          borderGray
          href={config.idc.mySkpCooperation}
          fontFixedLineHeight
        >
          Myスカパー！から
          <br />
          会員移行する
        </ButtonLink>
        <Button
          type="button"
          fillColor
          fontFixedLineHeight
          large
          onClick={onClickHandle}
        >
          スカパー！メンバーズ
          <br />
          会員登録へ進む
        </Button>
      </div>
    </div>
  );
}
